module.exports = __webpack_public_path__ + "static/media/our-goal.feac220e.jpg";